import { AbstractTrackDriver } from 'easyjs/lib/Tools/Tracker/AbstractTrackDriver';

export const EVENTS = {
    LOGIN: "login",
    CLICKED: "clicked",
    CHANGED_ROUTE: "changed_route"
}

class MixPanelDriver extends AbstractTrackDriver {

    constructor(mixPanelClient) {
        super();
        this.driver = mixPanelClient
    }

    set driver(obj) {
        window.mixPanelClient = obj;
    }

    get driver() {
        return window.mixPanelClient;
    }

    async register(id, props) {
        // super.register(id, props);
        await this.driver.people.set({
            ...props
        });
        return await this.driver.identify(id);
    }

    async trigger(currentUser, eventTrack, data) {
        const driver = this.driver;
        return driver.track(eventTrack, {
            ...data
        })
    }
}

export {
    MixPanelDriver
};